import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { cancelBrandingRun, isRunActive, listBrandingRuns, startBrandingRun } from '../api/docBranding';

const KEY = ['doc-branding', 'runs'];

/** Polls every few seconds while any run is still in progress, and not at all otherwise. */
export function useBrandingRuns() {
  return useQuery({
    queryKey: KEY,
    queryFn: listBrandingRuns,
    refetchInterval: (query) => (query.state.data?.runs.some((r) => isRunActive(r.status)) ? 4000 : false),
  });
}

export function useStartBrandingRun() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: startBrandingRun,
    onSettled: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useCancelBrandingRun() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelBrandingRun,
    onSettled: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}
